<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center block-step block-fullscreen-text">
      <h1 class="title-section">Pessoas</h1>
      <div class="title-main">
        <p>Quando começamos a falar sobre transformação digital, logo nos vemos discutindo tecnologia, hardware e automatizações. Entretanto, a transformação está focada na experiência que essas tecnologias podem proporcionar ao ser humano. Sabendo disso, é possível concluir que desenvolver inovações por si só, sem levar em consideração o comportamento humano, é um grande tiro no pé. Que tal começar refletindo sobre como as pessoas da sua organização estão relacionadas à tecnologia?</p>
      </div>
      <router-link :to="nextScreen" class="nav-arrow-down">
        <div class="title hidden-sm">
          Role para baixo
        </div>
        <icon name="arrow-line-right" class="arrow-right animation-blink" />
      </router-link>
    </section>
  </div>
</template>

<script>
import Icon from './Icon';
import rollDown from './mixins/rollDown';

/* eslint-disable max-len */
export default {
  name: 'peoples',
  mixins: [rollDown],
  components: { Icon },
  data() {
    return {
      nextScreen: '/pessoas/formulario',
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 2);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Peoples.vue